/**
 * @author vishwadeep.kapoor
 * @Date: 2019-05-07 14:43:18
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-26 16:10:06
 */

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { shape, bool, string, func, array } from 'prop-types';
import Helmet from 'react-helmet';
import { Card, Row, Col, Breadcrumb } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { selectGiftCardProduct, selectGiftCardDetails, select_GiftCardProductJS, select_GiftCardProductIsBoolean } from './selectors';
import { selectUserDetails, selectLoggedIn, getDefaultError, isMobileScreen } from '../HeaderContainer/selectors';
// import Breadcrumb from '../../components/Breadcrumb';
import Container from '../../components/Container';
import EGiftCard from './EGiftCard';
import Booking from './Booking';
import Terms from './terms';
import { fetchGiftCardDetails, successFetchGiftCardDetailsAction, SetProductContactUs } from './actions';
import { utils, constants, validations, fbTracker, eventTracking } from '../../devUtils';
import { ADDTOCART_PAYLOAD_STRUCTURE, ADDTOCART_PAYLOAD_STRUCTURE_PHYSICALCARD } from '../GiftCardsList/constants';
import { addToCartAction, createCart, fetchCartItemList, deleteCartItem } from '../GiftCardCart/actions';
import { CREATE_CART_PAYLOAD, CHECK_DELIVERY_TIME } from '../GiftCardCart/constants';
import { cartItemList, getAddtoCartResponse, select_isBoolean } from '../GiftCardCart/selectors';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { resetPopup } from '../HeaderContainer/actions';
import { displayLoginFrom } from '../LoginPage/actions';
import Loader from '../../components/Loader';
import { MANDATORY_FIELDS, GET_TAB_ACTIONTYPES, GIFTCARD_PRODUCT_VARIATIONS } from './constants';

const StyledGiftCardProductValue = styled.section`
  .gift-value{
    border: ${(props) => props.theme.lightGray} solid 1px;
    border-radius: 4px;
    padding: 10px;
    b{
      color: ${(props) => props.theme.primaryColor};
      font-size: 17px;
    }
  }

  .color-red{
    color: ${(props) => props.theme.primaryColor};
  }
`;

const free_message = 'Free field value must be in between :min and :max';

class GiftCardProduct extends PureComponent {
  constructor(props) {
    super(props);
    const { match: { params: { productName } }, getUserDetails: { email, phone, cart }, onFetchGiftCardDetails, getCartItemList } = props;
    this.clientId = '';
    this.currentActionType = '';
    this.validators = validations;
    this.state = {
      giftCardData: { product: {} },
      quantity: 1,
      email,
      phone,
      cart,
      variations: [],
      variationObj: {},
      cartItems: getCartItemList,
      showModal: false,
      activeTab: 'how_to_redeem',
      isBankCard: false,
      isShowValidation: false,
      defaultVariationType: [],
    };
    this.stateLessKeys = {
      temp_payload: {},
      visibility: true,
      isFreeFieldTouched: false,
      productName,
      recipientDetailsUpdateEventTrigger: false,
      isThisRedeempage: false,
      isVariationSelected: false,
      default_select: '',
    };
    onFetchGiftCardDetails({ productName });
    this.handleActions = this.handleActions.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.emptyCart = this.emptyCart.bind(this);
    this.goToOrderSummery = this.goToOrderSummery.bind(this);
    this.handleTabChanges = this.handleTabChanges.bind(this);
    this._updateValidators = this._updateValidators.bind(this);
  }

  componentWillMount() {
    const { history: { location: { state: { client_id = '' } = {} } = {} }, onGetCartItemsList } = this.props;
    this.clientId = (client_id === '') ? 'payment_gateway' : client_id;
    this.stateLessKeys.isThisRedeempage = (this.clientId !== 'payment_gateway');
    const { cart } = this.state;
    if (cart && cart.id) {
      this.cart = cart;
      onGetCartItemsList(cart.id);
    }
    // if (this.props.isLogedIn) {
    //   MANDATORY_FIELDS.forEach((element) => {
    //     this.validators = element === 'email' ? utils.updateValidators(this.validators, element, email) : utils.updateValidators(this.validators, element, phone);
    //   });
    //   this.setState({ isShowValidation: true });
    // }
  }

  componentWillReceiveProps(nextProps) {
    const {
      giftCardDeatils: giftCardData,
      getCartItemList: cartItems,
      getUserDetails,
      apiResonse,
      isLogedIn,
      getCartItemList,
      onGetCartItemsList,
    } = nextProps;
    const {
      giftCardDeatils: _giftCardDeatils,
      getUserDetails: _getUserDetails,
      isLogedIn: _isLogedIn,
      apiResonse: _apiResonse,
    } = this.props;
    if (!utils.isEqual(_giftCardDeatils, nextProps.giftCardDeatils)) {
      if (giftCardData.product && giftCardData.product.variations && giftCardData.product.variations.length) {
        const data = GIFTCARD_PRODUCT_VARIATIONS(utils.sortStringVariations(giftCardData.product.variations), null, giftCardData.product.product_type);
        const { product: { product_type, variation_types } } = giftCardData;
        if (data.length > 0) {
          const { quantity } = this.state;
          this.setState({ variations: CHECK_DELIVERY_TIME(data, quantity) });
          if (data && data.length && data.length === 1) {
            this.stateLessKeys.default_select = data[0].value;
            data[0].active = true;
          }
          this.chosenVariationValue(data);
        }
        let { isBankCard } = this.state;
        if (giftCardData.product.categories && giftCardData.product.categories.length) {
          const { categories } = giftCardData.product;
          const _isBankCard = utils.lodashFind(categories, { name: 'Bank Cards' });
          isBankCard = _isBankCard && _isBankCard.status;
        }
        const _variationType = [];
        if (giftCardData.product.variation_types && giftCardData.product.variation_types.length) {
          let _singleVariants = [];
          _singleVariants = variation_types.filter((item) => (item.values && item.values.length === 1));
          _singleVariants.forEach((item) => _variationType.push({ name: item.name, value: item.values[0] }));
        }
        this.stateLessKeys.visibility = giftCardData && giftCardData.product && giftCardData.product.visibility;
        this.setState({
          giftCardData,
          variations: data,
          isBankCard,
          activeTab: product_type === 'merchandise' ? 'description' : 'how_to_redeem',
          defaultVariationType: _variationType,
        });
      }
    }
    if (!utils.isEqual(this.props.getCartItemList, getCartItemList)) {
      this.setState({ cartItems });
    }
    if (!utils.isEqual(_getUserDetails, getUserDetails)) {
      const { email, phone, cart } = getUserDetails;
      this.setState({ email, phone, cart });
      MANDATORY_FIELDS.forEach((element) => {
        this.validators = element === 'email' ? utils.updateValidators(this.validators, element, email) : utils.updateValidators(this.validators, element, phone);
      });
      this.setState({ isShowValidation: true });
    }
    if (!utils.isEqual(_isLogedIn, isLogedIn)) {
      const { cart } = getUserDetails;
      if (cart && cart.id) {
        this.cart = cart;
        onGetCartItemsList(cart.id);
      }
    }
    if (!utils.isEqual(_apiResonse, apiResonse)) {
      if (apiResonse.msg_type === 'success') {
        this.validators = utils.resetValidators(this.validators);
      }
    }
  }

  /**
   * @description resetting the fetch changes to {}
   */
  componentWillUnmount() {
    this.props.onSuccessFetchGiftCardDetailsAction({});
  }

  chosenVariationValue(data) {
    const variationObj = {};
    let bFlag = false;
    for (let i = 0; i < data.length; i++) {
      if (data[i].active) {
        bFlag = true;
        variationObj.variationValue = data[i].free_field ? data[i].value : (data[i].price_cents) / 100;
        variationObj.price = data[i].value;
        variationObj.delivery_value = data[i].delivery_value;
        variationObj.product_image = data[i].image;
      }
    }
    if (!bFlag && data.length > 0) {
      variationObj.variationValue = data[0].free_field ? data[0].value : (data[0].price_cents) / 100;
      variationObj.price = data[0].value;
      variationObj.delivery_value = data[0].delivery_value;
      variationObj.product_image = data[0].image;
    }
    this.setState({ variationObj });
  }

  handleActions(type, value, id, otherParams) {
    if (type === 'addQuantity') {
      let { quantity, variations } = this.state;
      if (value === 'inc') {
        quantity += 1;
      } else if (value === 'dec' && quantity > 1) {
        quantity -= 1;
      }
      variations = CHECK_DELIVERY_TIME(variations, quantity);
      this.setState({ quantity, variations });
      this.chosenVariationValue(variations);
    } else if (type === 'variation') {
      this.stateLessKeys.isVariationSelected = (otherParams || false);
      const data = GIFTCARD_PRODUCT_VARIATIONS(this.state.variations, value, id);
      const data1 = utils.lodashFilter(data, { active: true });
      if (data1 && data1.length && data1[0].free_field) {
        this.stateLessKeys.isFreeFieldTouched = data1[0].free_field;
      }
      this.setState({ variations: data, isShowValidation: true });
      this.chosenVariationValue(data);
    } else if (['addToCart', 'buyNow'].includes(type)) {
      this.currentActionType = type;
      this.triggerAddToCart();
    } else if (type === 'updateEmail') {
      this.triggerRecipientdetailsUpdateEvent();
      this.setState({ email: value });
    } else if (type === 'updateMobile') {
      this.triggerRecipientdetailsUpdateEvent();
      this.setState({ phone: value });
    }
  }

  triggerRecipientdetailsUpdateEvent() {
    const { recipientDetailsUpdateEventTrigger, productName, isThisRedeempage } = this.stateLessKeys;
    if (!recipientDetailsUpdateEventTrigger) {
      this.stateLessKeys.recipientDetailsUpdateEventTrigger = true;
      eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', 'Product - Details Update', productName);
    }
  }

  closeModal() {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  goToOrderSummery() {
    const { history } = this.props;
    this.closeModal();
    utils.forceRedirect(history, { pathname: constants.LINK_ORDER_SUMMARY });
    // here need to trigger ordersummery page
  }

  emptyCart() {
    this.closeModal();
    const { cart: { id }, cartItems: cartData } = this.state;
    const { temp_payload, productName, isThisRedeempage } = this.stateLessKeys;
    const { history, onDeleteCartItem } = this.props;
    const dataObj = { items: [], cartId: id };
    // const clientid = cartData.order.zaggle_card_client_id;
    if (cartData && cartData.order && cartData.order.items.length > 0) {
      const dataItems = cartData.order.items;
      dataItems.forEach((element) => {
        dataObj.items.push({ product_variation_id: element.variation.id });
      });
    }
    onDeleteCartItem(dataObj, 'empty', this.clientId, temp_payload, this.currentActionType,
      history, { productName, isThisRedeempage, apiMethod: 'POST' });
  }

  /**
   * @todo 1) @func checkValidations can be removed as @func isFieldRequired can be @extends with_required_array
   * @todo 2) @func resetValidators can be removed and to be called only after success of the API_call @desc move to @func componentWillReceiveProps
   */
  triggerAddToCart() {
    const { isLogedIn, history, onAddToCartAction, onCreateCartAction, onChangeLoginModalDisplay } = this.props;
    const { quantity, variations, giftCardData, email, phone: phone_numbers, cart } = this.state;
    const { productName, isThisRedeempage } = this.stateLessKeys;
    const { id, free_field, value } = utils.lodashFind(variations, { active: true });

    if (giftCardData.product.product_type === 'merchandise' && !value) {
      return alert('Please choose a value');
    }
    if (isLogedIn) {
      const { isFreeFieldTouched } = this.stateLessKeys;
      let man_fields = [];
      if (isFreeFieldTouched && !free_field) {
        const { min_free_field_value, max_free_field_value } = utils.lodashFind(variations, { free_field: true });
        const data = JSON.stringify(utils.parseInteger(min_free_field_value) + 1);
        this._updateValidators('range', data, { min: min_free_field_value, max: max_free_field_value, message: free_message });
      } else if (free_field) {
        const { min_free_field_value, max_free_field_value, value: dataValue } = utils.lodashFind(variations, { free_field: true });
        this._updateValidators('range', dataValue, { min: min_free_field_value, max: max_free_field_value, message: free_message });
        man_fields = ['range'];
      }
      if (utils.isFieldRequired(this.validators, man_fields)) {
        this.setState({ isShowValidation: true });
      } else {
        // this.validators = utils.resetValidators(this.validators);
        this.setState({ isShowValidation: false });
        let payload = {};
        if (giftCardData.product.product_type === 'evoucher') {
          payload = ADDTOCART_PAYLOAD_STRUCTURE;
          payload.item.product_variation_id = id;
          payload.item.quantity = quantity;
          payload.item.shipping_address = { email, phone_numbers };
          payload.item.free_field_value = null;
        } else {
          payload = { ...ADDTOCART_PAYLOAD_STRUCTURE_PHYSICALCARD };
          payload.item.product_variation_id = id;
          payload.item.quantity = quantity;
          payload.item.free_field_value = null;
        }
        // payload.name = this.stateLessKeys.productName;
        if (free_field) {
          payload.item.free_field_value = value;
          this.checkFreeFieldValidation(utils.lodashFind(variations, { active: true }), payload);
        } else if (quantity === 0) {
          utils.showAlert(constants.QUANTITY_REQ);
        } else if (cart === null || Object.keys(cart).length === 0) {
          const data = { ...CREATE_CART_PAYLOAD };
          data.order.items.push(payload.item);
          data.order.zaggle_card_client_id = this.clientId;
          this.analyticsAddToCart(payload);
          onCreateCartAction(data, { actionType: this.currentActionType, history, productName, isThisRedeempage });
        } else {
          const { cartItems } = this.state;
          const apiMethod = this.checkIsAlreadyInCart();
          if (cart && cart.id && cartItems.order && !undefined && (cartItems.order.zaggle_card_client_id === this.clientId)) {
            this.analyticsAddToCart(payload);
            onAddToCartAction(payload, cart.id, this.currentActionType, history,
              { productName, isThisRedeempage, apiMethod });
          } else if (cart.items_count === 0 && cart.id) {
            // here comes cart has no items and clientId is not matched with requested product clientId
            // need to update exhisting clientId with requested clientId and add that product to cart
            const actionType = this.currentActionType === 'buyNow' ? 'updateClient&buyNow' : 'updateClient';
            const history_const = {
              clientId: this.clientId,
              cartId: cart.id,
              history,
            };
            this.analyticsAddToCart(payload);
            onAddToCartAction(payload, cart.id, actionType, history_const, { productName, isThisRedeempage, apiMethod });
          } else {
            this.closeModal();
            this.stateLessKeys.temp_payload = payload;
          }
        }
      }
    } else {
      // this.triggerError(constants.ALERT_LOGIN_REQUIRED);
      onChangeLoginModalDisplay(true);
      // utils.showAlert(constants.ALERT_LOGIN_REQUIRED);
    }
  }

  checkIsAlreadyInCart() {
    const { cartItems: { order: { items } }, variations } = this.state;
    if (items.length > 0 && variations.length > 0) {
      const activeVariation = utils.lodashFind(variations, { active: true });
      const isInCart = utils.lodashFind(items, { variation: { id: activeVariation.id } });
      if (utils.lodashIsObject(isInCart) && Object.keys(isInCart).length !== 0) {
        return 'PUT';
      }
    }
    return 'POST';
  }

  checkFreeFieldValidation(variationObj, payload) {
    const { history, onAddToCartAction, onCreateCartAction, onClearError } = this.props;
    const { cart } = this.state;
    const { productName, isThisRedeempage } = this.stateLessKeys;
    if (!(payload.item.quantity <= variationObj.max_free_field_quantity)) {
      const text = `Maximum Quantity possible is ${variationObj.max_free_field_quantity}`;
      onClearError(text, 'error');
      // this.props.onTriggerAlert(utils.errorResponse('api', text));
    } else if (cart === null || Object.keys(cart).length === 0) {
      const data = { ...CREATE_CART_PAYLOAD };
      data.order.items.push(payload.item);
      data.order.zaggle_card_client_id = this.clientId;
      this.analyticsAddToCart(payload);
      onCreateCartAction(data, { actionType: this.currentActionType, history, productName, isThisRedeempage });
    } else if (payload.item.free_field_value >= variationObj.min_free_field_value) {
      this.analyticsAddToCart(payload);
      onAddToCartAction(payload, cart.id, this.currentActionType, history, { productName, isThisRedeempage });
    }
  }

  handleTabChanges(event) {
    const { productName, isThisRedeempage } = this.stateLessKeys;
    eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', GET_TAB_ACTIONTYPES(event), productName);
    this.setState({ activeTab: event });
  }

  _updateValidators(type, value, otherParams) {
    this.validators = utils.updateValidators(this.validators, type, value, otherParams);
  }

  /**
   * @func analyticsAddToCart fb analytics
   */
  analyticsAddToCart({ item: { product_variation_id, quantity } = {} }) {
    const { giftCardDeatils: { product: { variations, name, id } = {} } } = this.props;
    const activeVariation_id = utils.lodashFind(variations, { id: product_variation_id }) || {};
    fbTracker.ADD_TO_CART(name, null, 'product', [{ id, quantity }], activeVariation_id.price_cents);
  }

  renderModalFooter() {
    return (
      <Fragment>
        <Button onClick={this.emptyCart}>Yes, Empty</Button>
        <Button onClick={this.goToOrderSummery}>No, I want to complete my order</Button>
      </Fragment>
    );
  }

  renderBreadcrumb() {
    const {
      giftCardDeatils: {
        product: {
          name,
        } = {},
      } = {},
      getUserDetails: {
        isOnlyMerchandise = false,
      },
    } = this.props;
    if (!isOnlyMerchandise) {
      return (
        <Breadcrumb separator="<" className="padding-tb-1">
          <Breadcrumb.Item href={constants.LINK_GIFTCARD_LIST}>Buy Gift Cards</Breadcrumb.Item>
          <Breadcrumb.Item>{name}</Breadcrumb.Item>
        </Breadcrumb>
      );
    }
    return '';
  }

  render() {
    const { isLoadingStatus,
      giftCardDeatils: { product: { expected_delivery_time, meta_data = {}, variation_types = [] } = {} } = {},
      onSetProductContactUs,
      GiftCardContact,
      isProductLoadingStatus,
      getUserDetails: {
        isOnlyMerchandise = false,
        client_series = '',
      },
      isMobileWindow,
    } = this.props;
    const {
      quantity,
      email,
      phone,
      variations,
      showModal,
      activeTab,
      isBankCard,
      isShowValidation,
      variationObj,
      variationObj: { delivery_value, variationValue } = {},
      giftCardData: { product, product: { product_type, discounts_percent } = {} } = {},
      defaultVariationType,
    } = this.state;
    const { visibility, isVariationSelected, default_select } = this.stateLessKeys;
    const discountPersent = discounts_percent &&
      discounts_percent.payment_gateway &&
      parseFloat(discounts_percent.payment_gateway) > 0;
    let giftCardValue = variationValue;
    let result = (parseFloat(giftCardValue) * parseFloat(discounts_percent && discounts_percent.payment_gateway)) / 100;
    let savedPrice = parseFloat(giftCardValue) - result;
    if (quantity > 1) {
      result *= quantity;
      savedPrice *= quantity;
      giftCardValue *= quantity;
    }
    if (isLoadingStatus || isProductLoadingStatus) {
      return <Loader />;
    }
    return (
      <Fragment>
        <Helmet>
          <title> {meta_data.title || 'Zaggle - Gift cards Product'} </title>
          <meta name="description" content={meta_data.description} />
          <meta name="keywords" content={meta_data.keywords} />
        </Helmet>
        <Container>
          <Row align="middle" type="flex" gutter={24}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left margin-t-3">
              <h1 className="font-26 nomargin">{isOnlyMerchandise ? 'Buy Merchandise' : 'Buy Gift Cards'}</h1>
              {this.renderBreadcrumb()}
            </Col>
          </Row>
          <Modal
            show={showModal}
            header="Empty Cart?"
            onClose={this.closeModal}
            footer={this.renderModalFooter()}
          ><span>Few items in your cart can not redeemed using `{'zaggle cash / selected zaggle card'}`.Do you want to empty your cart first ?</span>
          </Modal>
          <Card className="rounded noborder noshadow">
            <Row align="top" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} />
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <EGiftCard
                  cardData={product}
                  clientid={this.clientId}
                  quantity={quantity}
                  isBankCard={isBankCard}
                  variationObj={variationObj}
                  isVariationSelected={isVariationSelected}
                  isMobileWindow={isMobileWindow}
                // productName={productName}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Booking
                  variations={variations}
                  handleChildActions={this.handleActions}
                  quantity={quantity}
                  email={email}
                  phone={phone}
                  voucherType={product_type}
                  clientid={this.clientId}
                  isBankCard={isBankCard}
                  variationObj={variationObj}
                  cardData={product}
                  visibility={visibility}
                  isShowValidation={isShowValidation}
                  _childUpdateValidators={this._updateValidators}
                  validators={this.validators}
                  default_select={default_select}
                  client_series={client_series}
                  defaultVariationType={defaultVariationType}
                  {...{ variation_types, onSetProductContactUs, GiftCardContact, isProductLoadingStatus }}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <StyledGiftCardProductValue>
                  <Card className="rounded card-padding-0 margin-t-3">
                    <Row align="middle" type="flex">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="gray-bg">
                        <h2 className="font-14 nomargin padding-1">Delivery Time: <b>{expected_delivery_time || delivery_value}</b></h2>
                      </Col>
                    </Row>
                    <Row align="middle" type="flex">
                      <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                        <h1 className="font-14 padding-1 padding-l-2">Total</h1>
                      </Col>
                    </Row>
                    <Row align="middle" type="flex">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-l-2">
                        {this.clientId === 'payment_gateway' && discountPersent ? (
                          <span className="gift-value">
                            <span><b>&#8377;&nbsp;{savedPrice}</b></span> <strike>&#8377;&nbsp;{giftCardValue}</strike> <strong>(You Save:&#8377;&nbsp;{result})</strong>
                          </span>) : (<span className="gift-value"><b>&#8377;&nbsp;{giftCardValue}</b></span>)}
                        { giftCardValue < 0 ? (
                          <div className="color-red padding-t-1 ">
                            Please select valid options
                          </div>
                        ) : ''
                        }
                      </Col>
                    </Row>
                    <div className="footer margin-2">
                      <Button
                        className="padding-1"
                        onClick={() => this.handleActions('addToCart')}
                      >Add to Cart
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                      <Button
                        type="primary"
                        className="padding-1"
                        onClick={() => this.handleActions('buyNow')}
                      >
                        Buy Now
                      </Button>
                    </div>
                  </Card>
                </StyledGiftCardProductValue>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Terms
                  metadata={product}
                  activeTab={activeTab}
                  onTabClick={this.handleTabChanges}
                />
              </Col>
            </Row>
          </Card>
        </Container>
      </Fragment>
    );
  }
}

GiftCardProduct.propTypes = {
  isLoadingStatus: bool.isRequired,
  isProductLoadingStatus: bool.isRequired,
  isLogedIn: bool.isRequired,
  isMobileWindow: bool.isRequired,
  giftCardDeatils: shape({}).isRequired,
  getUserDetails: shape({
    email: string,
    phone: string,
    cart: shape({}),
  }).isRequired,
  match: shape({
    params: shape({
      giftCardId: string,
      page: string,
    }),
  }).isRequired,
  variations: array,
  getCartItemList: shape({}).isRequired,
  history: shape({}).isRequired,
  // addToCartResponse: object,
  apiResonse: shape({}).isRequired,
  GiftCardContact: shape({}).isRequired,
  onSuccessFetchGiftCardDetailsAction: func.isRequired,
  onClearError: func.isRequired,
  onChangeLoginModalDisplay: func.isRequired,
  onFetchGiftCardDetails: func.isRequired,
  onAddToCartAction: func.isRequired,
  onCreateCartAction: func.isRequired,
  onGetCartItemsList: func.isRequired,
  onDeleteCartItem: func.isRequired,
  onSetProductContactUs: func.isRequired,
};


const mapDispatchToProps = (dispatch) => ({
  onFetchGiftCardDetails: (payload) => dispatch(fetchGiftCardDetails(payload)),
  onSetProductContactUs: (payload) => dispatch(SetProductContactUs(payload)),
  onSuccessFetchGiftCardDetailsAction: (payload) => dispatch(successFetchGiftCardDetailsAction(payload)),
  onAddToCartAction: (payload, product_id, type, history, trackingObj) => dispatch(addToCartAction(payload, product_id, type, history, trackingObj)),
  onCreateCartAction: (payload, otherProps) => dispatch(createCart(payload, otherProps)),
  onGetCartItemsList: (payload) => dispatch(fetchCartItemList(payload)),
  onDeleteCartItem: (payload, actionType, clientid, req_payload, req_action, history, trackingObj) => dispatch(deleteCartItem(payload, actionType, clientid, req_payload, req_action, history, trackingObj)),
  onClearError: (payload, actionType) => dispatch(resetPopup(payload, actionType)),
  onChangeLoginModalDisplay: (payload) => dispatch(displayLoginFrom(payload)),
});

const mapStateToProps = createStructuredSelector({
  GiftCardProduct: selectGiftCardProduct(),
  GiftCardContact: select_GiftCardProductJS('giftCardContact'),
  giftCardDeatils: selectGiftCardDetails(),
  getUserDetails: selectUserDetails(),
  isLogedIn: selectLoggedIn(),
  getCartItemList: cartItemList(),
  addToCartResponse: getAddtoCartResponse(),
  isLoadingStatus: select_isBoolean('isLoading'),
  isProductLoadingStatus: select_GiftCardProductIsBoolean('isLoading'),
  apiResonse: getDefaultError(),
  isMobileWindow: isMobileScreen(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(GiftCardProduct));
export { GiftCardProduct, mapDispatchToProps, mapStateToProps };
export default component;




// WEBPACK FOOTER //
// client/containers/GiftCardProduct/index.js